// i18n/I18nContext.js — Contexte de traduction multi-langue
import React, { createContext, useContext, useState, useEffect } from 'react';
import fr from './fr';
import ar from './ar';
import tz from './tz';

const LANGS = { fr, ar, tz };

export const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('darna-immo_lang') || 'fr';
  });

  const t = LANGS[lang] || LANGS.fr;

  useEffect(() => {
    localStorage.setItem('darna-immo_lang', lang);
    document.documentElement.setAttribute('dir', t.dir);
    document.documentElement.setAttribute('lang', lang);
    // Même police pour toutes les langues
    document.body.style.fontFamily = '';
  }, [lang, t.dir]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t, langs: Object.values(LANGS) }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used inside I18nProvider');
  return ctx;
}
